import { UserRightsEnum } from '@evasys/globals/shared/enums/business/user-rights.enum';

export interface ProductMenuItem {
	id: string;
	name: string;
	url?: URL | string;
	rights?: UserRightsEnum[];
	isActive?: boolean;
}
